export const getCartSKU = (mutation: MutationRecord) => {
  let cartSKU: string | undefined;

  if (mutation.type === 'childList' && mutation.addedNodes[0]) {
    const storedCartSKUs: string[] = JSON.parse(
      localStorage.getItem('fp-skus') || '[]'
    );
    const cartItemsElementsCount = storedCartSKUs.length + 1;

    for (let i = 0; i < cartItemsElementsCount; i++) {
      const addedNode = mutation.addedNodes[i] as HTMLElement;
      const classList = addedNode?.classList;

      if (classList && classList.contains('w-commerce-commercecartitem')) {
        for (let j = 0; j < cartItemsElementsCount; j++) {
          const cartItemSkuArray = addedNode.querySelectorAll(
            `[data-wf-bindings="%5B%7B%22innerHTML%22%3A%7B%22type%22%3A%22PlainText%22%2C%22filter%22%3A%7B%22type%22%3A%22identity%22%2C%22params%22%3A%5B%5D%7D%2C%22dataPath%22%3A%22database.commerceOrder.userItems.${j}.sku.f_sku_%22%7D%7D%5D"]`
          );
          const sku = cartItemSkuArray[0]?.innerHTML;
          // console.log('sku', sku);
          if (sku) {
            cartSKU = sku;
          }
        }
      }
    }
  }

  return cartSKU;
};
